import React, { useContext } from 'react'
import { useNavigate } from 'react-router-dom'

import { PAGE_TITLE } from '../../Configuration'
import usePageTitle from '../../hooks/use-page-title'
import { RoleContext } from '../../store/role-context-provider'
import { SelectionContextProvider } from '../../store/selection-context-provider'
import InquiriesList from './inquiries-list'


const Inquiries = (props: any) => {
  usePageTitle(PAGE_TITLE.INQUIRIES)
  const navigate = useNavigate()
  const { allMPF, isLoading } = useContext(RoleContext)
  if (!isLoading) {
    if (!allMPF) {
      navigate('/accessdenied')
    }
  }
  return (
    <SelectionContextProvider>
      <InquiriesList isMenusExpanded={props?.isMenusExpanded}/>
    </SelectionContextProvider>
  )
}
export default Inquiries
